import Swiper from "swiper";
import { Navigation} from 'swiper/modules';
import {hoverItemImage} from "./partials/hoverItemImage";


document.addEventListener('mouseup', () => {
    setTimeout(function () {
        for(let img of document.querySelectorAll(".itemlistItem__image img")){
            hoverItemImage(img);
        }
    },200);
});
window.addEventListener("load", () => {

    let itemlistImages = document.querySelectorAll(".itemlistItem__image img");
    for(let img of itemlistImages){
        setTimeout(function () {
            hoverItemImage(img);
        },200);
    }

    for (let itemlist of document.querySelectorAll(".itemList.swiper")) {
        const isBannerWithArticle = itemlist.closest(".bannerWrapper--withArticle") !== null;
        // A list may show more tiles on mobile, e.g. the teamshop basket carousel (data-mobile-slides-per-view="2.5")
        const mobileSlidesPerView = parseFloat(itemlist.dataset.mobileSlidesPerView) || 1.25;
        // A list may space its tiles wider, as "mobile,768,1024" in px, e.g. data-space-between="16,24,32"
        const [spaceMobile, spaceTablet, spaceDesktop] = (itemlist.dataset.spaceBetween || '').split(',').map(parseFloat);

        const bp = {
            0: {slidesPerView: isBannerWithArticle ? 1 : mobileSlidesPerView, spaceBetween: isBannerWithArticle ? 0 : (spaceMobile || 10), loop: false},
            768: {slidesPerView: isBannerWithArticle ? 1 : 3, spaceBetween: isBannerWithArticle ? 0 : (spaceTablet || 16), loop: false},
            1024: {slidesPerView: isBannerWithArticle ? 1 : 4, spaceBetween: isBannerWithArticle ? 0 : (spaceDesktop || 24), loop: false},
        };

        const countRealSlides = itemlist.querySelectorAll('.swiper-wrapper .swiper-slide').length;

        for (const [key, bpItem] of Object.entries(bp)) {
            if (countRealSlides > bpItem.slidesPerView) {
                bpItem.loop = true;
            }
        }

        // Erstelle externe Navigation für Banner-Elemente
        let nextEl, prevEl;
        if (isBannerWithArticle) {
            // Externe Navigation erstellen falls nicht vorhanden
            let externalNav = itemlist.querySelector('.external-swiper-navigation');
            if (!externalNav) {
                externalNav = document.createElement('div');
                externalNav.className = 'external-swiper-navigation';
                externalNav.innerHTML = `
                    <div class="swiper-button-prev-external">
                        <i class="icon icon-angle-left"></i>
                    </div>
                    <div class="swiper-button-next-external">
                        <i class="icon icon-angle-right"></i>
                    </div>
                `;
                itemlist.appendChild(externalNav);
            }
            nextEl = itemlist.querySelector('.swiper-button-next-external');
            prevEl = itemlist.querySelector('.swiper-button-prev-external');
        } else {
            nextEl = itemlist.querySelector('.swiper-button-next');
            prevEl = itemlist.querySelector('.swiper-button-prev');
        }

        const swiper = new Swiper(itemlist, {
            modules: [Navigation],
            watchOverflow: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: bp
        });
    }

});

